module.exports = __webpack_public_path__ + "static/media/money-angel.15d58a34.png";